export default __webpack_public_path__ + "static/edi_swe-8ae1d228d254089908063832f63f2417.svg";